export default __webpack_public_path__ + "static/media/ODORImg.fe09205d.png";